export default __webpack_public_path__ + "static/media/zube.c3ac2c5e.svg";